<div
  [class]="
    'flex items-center flex-col max-h-5 overflow-hidden whitespace-nowrap rounded-[6px] box-border py-1 px-[6px] ' +
    (borderColor || 'border-neutrals-300') +
    ' ' +
    getBackgroundColor()
  "
  [style.max-width]="truncate ? width : null"
  [style.width]="!truncate ? width : null"
  *ngIf="value"
>
  <ui-paragraph
    class="whitespace-nowrap max-w-full"
    [ngClass]="{ 'overflow-hidden text-ellipsis': truncate }"
    type="p8"
    mobile-type="p8"
    font-weight="semibold"
    text-color="neutrals-900"
  >
    {{ value }}
  </ui-paragraph>
</div>
